import React from 'react';
import {animated, useTransition} from 'react-spring';
import FormComponent from '../form-component';
import FormControls from '../form-controls';
import FormStep from '../form-step';
import FormContext from './FormContext';
import useForm from './useForm';
import {TRANSITION_DIRECTION} from '../../../constant/Application';
import {FORM_CONFIGURATION} from '../../../constant/Form';
import {FORM_STEP_ORDER} from '../../../constant/FormStep';

import './Form.css';

const steps = FORM_STEP_ORDER.map(stepKey => ({style}) => {
  const stepConfiguration = FORM_CONFIGURATION[stepKey];

  if (stepConfiguration) {
    const {components, formStepProps} = stepConfiguration;

    return (
      <animated.div style={style}>
        <FormStep {...formStepProps}>
          {components.map(componentConfiguration => {
            const {key, component : Component, metadata = {}, props = {}} = componentConfiguration;

            return (
              <FormComponent {...metadata} props={props} key={key}>
                <Component {...props} />
              </FormComponent>
            );
          })}
        </FormStep>
      </animated.div>
    );
  }

  return null;
});

const identity = item => item;

function Form () {
  const {formContext, stepIndex, transitionDirection} = useForm();
  const animateForward = transitionDirection === TRANSITION_DIRECTION.FORWARD;
  const transitions = useTransition(stepIndex, identity, {
    from  : {
      position   : 'absolute',
      opacity    : 0,
      transform  : animateForward ? 'translate3d(0, 100%, 0)' : 'translate3d(0, -100%, 0)',
      width     : '100%'
    },
    enter : {
      opacity   : 1,
      transform : 'translate3d(0%, -60%, 0)',
      width     : '100%'
    },
    leave : {
      opacity   : 0,
      transform : animateForward ? 'translate3d(0, -100%, 0)' : 'translate3d(0, 100%, 0)',
      width     : '100%'
    }
  });

  return (
    <FormContext.Provider value={formContext}>
      <article className="form">
        {transitions.map(({ item, props, key }) => {
          const Step = steps[item];

          return (
            <Step key={key} style={props} />
          );
        })}

        <FormControls />
      </article>
    </FormContext.Provider>
  );
}

export default Form;
